import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

interface DemandStats {
  max_kw: number;
  max_kw_peak_hours: number;
}

interface DemandStatsComparisonResponse {
  success: boolean;
  original: DemandStats;
  aligned: DemandStats;
  error?: string;
}

export function useDemandStatsComparison(
  projectId: string | undefined,
  isAligned: boolean
) {
  return useQuery<DemandStatsComparisonResponse>({
    queryKey: ['demandStatsComparison', projectId],
    queryFn: async () => {
      const response = await axios.get<DemandStatsComparisonResponse>(
        `${API_BASE_URL}/projects/${projectId}/demand-stats-comparison`
      );
      return response.data;
    },
    enabled: !!projectId && isAligned,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
